<template>
  <NotificationsWrapper @showReportsDrawer="$emit('showReportsDrawer', $event)">
    <v-list
      v-if="notifications.length > 0"
      slot-scope="{ onNotificationClick }"
      class="pa-0 ma-0"
    >
      <Notification
        v-for="(notification, index) in notifications"
        :key="notification._id + index"
        :notification="notification"
        @click="onNotificationClick(notification)"
      />
    </v-list>
    <div v-else class="d-flex flex-row justify-center align-center pa-4">
      <v-icon large>mdi-bell-circle-outline</v-icon>
      <p class="ms-2 mb-0">
        {{ $t('notifications.you_dont_have_any_notifications_right_now') }}
      </p>
    </div>
  </NotificationsWrapper>
</template>

<script>
import Notification from '@/components/Notifications/Notification.vue'
import NotificationsWrapper from '@/components/Notifications/NotificationsWrapper.vue'
export default {
  name: 'NotificationsListContainer',
  components: {
    Notification,
    NotificationsWrapper,
  },

  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },
}
</script>
